import { render, staticRenderFns } from "./SiteStats.vue?vue&type=template&id=3ef00f6e&"
import script from "./SiteStats.vue?vue&type=script&lang=ts&"
export * from "./SiteStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports